import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login-wrap"
};
const _hoisted_2 = {
  class: "holder holder-fluid"
};
const _hoisted_3 = {
  class: "back"
};
const _hoisted_4 = {
  class: "login"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Забыли пароль?", -1);

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "form-text"
}, "Укажите свой email и мы отправим вам ссылку для восстановления пароля", -1);

const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "email-input",
  class: "label"
}, "Email", -1);

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "form-button"
}, [/*#__PURE__*/_createElementVNode("button", {
  class: "button"
}, "Отправить ссылку")], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goBack && $options.goBack(...args)),
    style: {
      "cursor": "pointer"
    }
  }, "Вернуться назад")]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.handlerSubmit && $options.handlerSubmit(...args), ["prevent"]))
  }, [_createElementVNode("fieldset", null, [_hoisted_7, _withDirectives(_createElementVNode("input", {
    id: "email-input",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.email = $event),
    type: "text",
    class: "input",
    placeholder: "Введите email"
  }, null, 512), [[_vModelText, $data.form.email]]), _hoisted_8])], 32)])])]);
}